<template>
<div id="history">
    <div class="container-fluid">
        <div class="col-sm-12 col-sm-push-1">
            <h4>{{ title }}</h4>
            <hr>
            <div class="row">
                <div class="col-sm-11">
                    <form class="form">
                        <div class="form-group row">
                            <div class="col-sm-2">
                                <label class="control-label" for="start_date">{{ label.start_date }}</label>
                            </div>
                            <div class="col-sm-3">
                                <input type="date" class="form-control" required id="start_date"  v-model="formData.start_date" >
                            </div>
                            <div class="col-sm-2">
                                <label class="control-label" for="end_date">{{ label.end_date }}</label>
                            </div>
                            <div class="col-sm-3">
                                <input type="date" class="form-control" required id="end_date"  v-model="formData.end_date" >
                            </div>
                        </div>

                        <div class="form-group row">
                                <div class="col-sm-2" >
                                    <span style="color: blue">Filter By </span>
                                </div>


                            </div>

                            <div class="form-group row">
                                <div class="col-sm-2" >
                                    <label class="control-label">{{ label.project_id }}</label>
                                </div>
                                <div class="col-sm-3">
                                    <select class="form-control" v-model="reqCrit.project_id" v-on:change="setProjectsSelection()">
                                        <option v-for="(item, index) in projects" :key="index" v-bind:value="{id: item.id, name: item.display_name}">{{ item.display_name }}</option>
                                    </select>
                                    <div>
                                        <span v-if="projectSelection != '' ">Selected:
                                            <ul style="list-style: none;" v-for="(item, index) in projectSelection" :key="index">
                                                <li><v-icon @click="delProjectsSelection(index)">delete</v-icon>{{ item.name }} </li>
                                            </ul>
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group row">
                                <div class="col-sm-2" >
                                    <label class="control-label">{{ label.reason_id }}</label>
                                </div>
                                <div class="col-sm-3">
                                    <select class="form-control" v-model="reqCrit.reason_id" v-on:change="setReasonsSelection()">
                                        <option v-for="(item, index) in reasons" :key="index" v-bind:value="{id : item.id, name: item.display_name}">{{ item.display_name }}</option>
                                    </select>
                                    <div>
                                        <span v-if="reasonSelection != '' ">Selected:
                                            <ul style="list-style: none;" v-for="(item, index) in reasonSelection" :key="index">
                                                <li><v-icon  @click="delReasonsSelection(index)">delete</v-icon>{{ item.name }} </li>
                                            </ul>
                                        </span>
                                    </div>
                                </div>


                            </div>

                            <div class="form-group row">
                                <div class="col-sm-2" >
                                    <label class="control-label">{{ label.company_id }}</label>
                                </div>
                                <div class="col-sm-3">
                                    <select class="form-control" v-model="reqCrit.company_id" v-on:change="setCompaniesSelection()">
                                        <option v-for="(item, index) in companies" :key="index" v-bind:value="{id : item.id, name: item.display_name}">{{ item.display_name }}</option>
                                    </select>
                                    <div>
                                        <span v-if="companySelection != '' ">Selected:
                                            <ul style="list-style: none;" v-for="(item, index) in companySelection" :key="index">
                                                <li><v-icon @click="delCompaniesSelection(index)">delete</v-icon>{{ item.name }} </li>
                                            </ul>
                                        </span>
                                    </div>
                                </div>
                            </div>

                             <div class="form-group row">
                                <div class="col-sm-2" >
                                    <label class="control-label">{{ label.geolocation_id }}</label>
                                </div>
                                <div class="col-sm-3">
                                    <select class="form-control" v-model="reqCrit.geolocation_id" v-on:change="setGeolocationsSelection()">
                                        <option v-for="(item, index) in geolocation" :key="index" v-bind:value="{id : item.id, name: item.location_name}">{{ item.location_name }}</option>
                                    </select>
                                    <div>
                                        <span v-if="geolocationSelection != '' ">Selected:
                                            <ul style="list-style: none;" v-for="(item, index) in geolocationSelection" :key="index">
                                                <li><v-icon @click="delGeolocationsSelection(index)">delete</v-icon>{{ item.name }} </li>
                                            </ul>
                                        </span>
                                    </div>
                                </div>
                            </div>

                        <div class="form-group row text-center">
                            <div v-if="loading" class="col-sm-11">
                                <button type="button" class="btn btn-default" @click="dateValidation" disabled>REFRESH</button>
                            </div>
                            <div v-else class="col-sm-11">
                                <button type="button" class="btn btn-primary" @click="dateValidation" >REFRESH</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">


                    <a href="" @click.prevent="printPDF()" target="_blank"><img src="../../assets/images/print.png" alt="export to PDF" style="height: 22px; float: right; padding-left: 8px; margin-bottom: 5px;"></a>
                    <a href="" @click.prevent="getCSV"><img src="../../assets/images/download.png" style="height: 22px; float: right;"></a>

                </div>
            </div>
            <div class="row ">
                <div class="col-sm-12" >
                    <app-readonly-table-map
                        v-bind:parentData="{
                            headers: this.headers,
                            records: this.histories
                        }"
                        v-on:update-prop="updateComponent($event)"
                    ></app-readonly-table-map>
                    <P></P>
                    <div v-show="nextPage" class="form-group row text-center">
                        <div class="col-sm-11">
                            <button type="button" class="btn btn-primary" @click="loadMore" >FETCH NEXT 10 RECORDS</button>
                        </div>
                    </div>
                </div>
                <div>
                  <v-dialog v-model="dialogPhoto" max-width="500px">
                    <v-card>
                      <img :src="photoHolder">
                    </v-card>
                    <v-card-actions class="justify-center">
                      <v-btn @click="dialogPhoto = false">CLOSE</v-btn>
                    </v-card-actions>
                  </v-dialog>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import axios from 'axios'
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import moment from 'moment'
import { setTimeout } from 'timers';

import ReadOnlyTableMaps from '../shared/ReadOnlyTableMaps'

import { toggleInOut, enableToggle, yesNoToggle, formatUXDate, formatUXTime, formatUXDateTime } from '../common/toggle.js'

export default {
    components: {
        'app-readonly-table-map': ReadOnlyTableMaps
    },

    data () {
        return {
            title: 'CLOCKING RECORDS',
            label: {
                start_date: 'Records From',
                end_date: 'Records To',
                project_id: 'Project',
                reason_id: 'Reason',
                company_id: 'Company',
                geolocation_id: 'Geofencing',
            },
            formData: {
                start_date: moment().format('YYYY-MM-DD'),
                end_date: moment().format('YYYY-MM-DD')
            },
            headers: [
                    { text: 'FULL NAME', value: 'employee_name', sortable: true },
                    { text: 'COMPANY', value: 'company_name', sortable: true },
                    { text: 'DATE', value: 'localtime_at', sortable: true },
                    { text: 'TIME', value: 'localtime_at', sortable: true },
                    { text: 'SYSTEM TIME', value: 'clocking_at', sortable: true },
                    { text: 'IN/OUT', value: 'clock_in_out', sortable: false },
                    { text: 'REASON', value: 'reason_name', sortable: true },
                    { text: 'PROJECT', value: 'project_name', sortable: true },
                    { text: 'ID', sortable: false, value: 'id_number', sortable: false },
                    { text: 'LOCATION', sortable: false, value: 'location', sortable: false },
                    { text: 'PHOTO CLOCKIN', sortable: false, value: 'photo_clockin'},
                    { text: 'PHOTO CLOCKOUT', sortable: false, value: 'photo_clockout'},
                    { text: 'GEOLOCATION CODE', value: 'geolocation_code', sortable: true },
                    { text: 'GEOLOCATION NAME', value: 'geolocation_name', sortable: true },
                    
            ],
            nextPage: false,
            pagination: {'sortBy': 'localtime_at', 'sortBy': 'localtime_at', 'descending': true, 'rowPerPage': -1},
            loading: false,
            histories: [],
            page: 1,
            per_page: 10,
            start_date: '',
            end_date: '',
            dialogMap: false,
            center: {lat: 10, lng: 10},
            markers: [],
            reqCrit: {
                start_date: moment().format('YYYY-MM-DD'),
                end_date: moment().format('YYYY-MM-DD'),
                project_id: '',
                reason_id: '',
                company_id: '',
                geolocation_id: '',
            },
            projects: [],
            reasons: [],
            companies: [],
            geolocation: [],
            reasonSelection: [],
            projectSelection: [],
            companySelection: [],
            geolocationSelection: [],
            loading: false,
            dialogPhoto: false,
            photoHolder: null,
        }
    },

    computed: {
        pages() {
            if (this.pagination.rowsPerPage == null ||
                    this.pagination.totalItems == null
            ) return 0

            return Math.cell(this.pagination.totalItems / this.pagination.rowsPerPage)
        }
    },

    methods: {
        setReasonsSelection() {
            var reasonsSel = []

            if (this.reqCrit.reason_id !== null) {
                reasonsSel.push(this.reqCrit.reason_id)

                for (let i =0; i < reasonsSel.length; ++i) {
                    this.reasonSelection.push(reasonsSel[i])
                }
            }

        },

        delReasonsSelection(i) {
            this.reqCrit.reason_id = ''
            this.reasonSelection.splice(i, 1)
        },

        setProjectsSelection() {
            var projectSel = []

            if (this.reqCrit.project_id !== null) {
                projectSel.push(this.reqCrit.project_id)

                for (let i =0; i < projectSel.length; ++i) {
                    this.projectSelection.push(projectSel[i])
                }
            }

        },

        delProjectsSelection(i) {
            //document.getElementById("projectOption").selectedIndex = "-1"
            this.reqCrit.project_id = ''
            this.projectSelection.splice(i, 1)

        },

        setCompaniesSelection() {
            var companySel = []

            if (this.reqCrit.company_id !== null) {
                companySel.push(this.reqCrit.company_id)

                for (let i =0; i < companySel.length; ++i) {
                    this.companySelection.push(companySel[i])
                }
            }

        },

        delCompaniesSelection(i) {
            this.reqCrit.company_id = ''
            this.companySelection.splice(i, 1)
        },

          setGeolocationsSelection() {
            var geolocationSel = []

            if (this.reqCrit.geolocation_id !== null) {
                geolocationSel.push(this.reqCrit.geolocation_id)

                for (let i =0; i < geolocationSel.length; ++i) {
                    this.geolocationSelection.push(geolocationSel[i])
                }
            }

        },

        delGeolocationsSelection(i) {
            this.reqCrit.geolocation_id = ''
            this.geolocationSelection.splice(i, 1)
        },

        retriveProjects() {
            let vm = this

            axios.get(this.$store.getters.rootAPI + '/clock/projects/list')
            .then(function (response) {
                vm.projects = response.data.rec;
            })
            .catch(function (error) {
                vm.status = 'An error occured.' + error;
            })
        },

        retriveReasons() {
            let vm = this

            axios.get(this.$store.getters.rootAPI + '/clock/reason/list')
            .then(function (response) {
                vm.reasons = response.data.rec;
            })
            .catch(function (error) {
                vm.status = 'An error occured.' + error;
            })
        },

        retriveCompanies() {
            let vm = this

            axios.get(this.$store.getters.rootAPI + '/company/list')
            .then(function (response) {
                vm.companies = response.data.rec;
            })
            .catch(function (error) {
                vm.status = 'An error occured.' + error;
            })
        },

        retriveGeolocation() {
            let vm = this

            axios.get(this.$store.getters.rootAPI + '/geolocation/list')
            .then(function (response) {
                vm.geolocation = response.data.rec;
            })
            .catch(function (error) {
                vm.status = 'An error occured.' + error;
            })
        },

        dateValidation() {

            if (this.formData.start_date > this.formData.end_date || this.formData.end_date < this.formData.start_date) {
                alert(this.label.start_date + " should be ealier than " + this.label.end_date)
            } else {
                this.loadHistory()
            }
        },

        loadHistory() {
            var vm = this

            var reasonList = []
            var projectList = []
            var companyList = []
            var geolocationList = []

            for (let i = 0; i < this.reasonSelection.length; ++i) {
                reasonList.push(this.reasonSelection[i].id)
            }

            for (let i = 0; i < this.projectSelection.length; ++i) {
                projectList.push(this.projectSelection[i].id)
            }

            for (let i = 0; i < this.companySelection.length; ++i) {
                companyList.push(this.companySelection[i].id)
            }

            for (let i = 0; i < this.geolocationSelection.length; ++i) {
                geolocationList.push(this.geolocationSelection[i].id)
            }

            var payload = {
                page: this.page,
                per_page: this.per_page,
                start_date: this.formData.start_date,
                end_date: this.formData.end_date,
                reason_id: reasonList,
                project_id: projectList,
                company_id: companyList,
                geolocation_id: geolocationList
            }

            this.loading = !this.loading;

            axios.post(this.$store.getters.rootAPI + '/clock/admin_history', payload)
            .then(function (response) {
                if (response.status !== 401) {
                    vm.histories = response.data.rec;
                    for (let i = 0; i < vm.latest.length; i++) {
                      vm.histories[i].toggle = false;
                    }

                let totalRecords = vm.histories.length

                vm.loading = !vm.loading;
                //if (totalRecords >= 10) vm.nextPage = true
                }
            })
            .catch(function (error) {
                vm.status = 'An error occured.' + error;
            })

        },

        loadMore() {
            var vm = this

            axios.post(this.$store.getters.rootAPI + '/clock/admin_history', {
                page: vm.page + 1,
                per_page: vm.per_page,
                start_date: vm.formData.start_date,
                end_date: vm.formData.end_date
            })
            .then(function (response) {
                vm.histories = [vm.histories, ...response.data.rec];
                vm.page = vm.page + 1
                let totalRecords = vm.histories.length

                if (totalRecords >= 10) {
                    vm.nextPage = true
                } else {
                    vm.nextPage = false
                }

            })
            .catch(function (error) {
                vm.status = 'An error occured.' + error;
            })
        },

        redirectTo(path) {
            this.$router.push(path)
        },

        updateComponent(photo){
          var vm = this
          vm.photoHolder = photo
          vm.dialogPhoto = !vm.dialogPhoto
        },

        objectToCSV(data) {
            const csvRows = []

            // get header
            const headers = Object.keys(data[0])
            csvRows.push(headers.join(','))

            // loop over the rows
            for (const row of data) {
                const values = headers.map(header => {
                    const escaped = ('' + row[header]).replace(/"/g, '\\"')
                    return `"${escaped}"`
                })
                csvRows.push(values.join(','))
            }
            return csvRows.join('\n')
        },

        download(data) {
            const blob = new Blob([data], { type: 'text/csv'})
            const url = window.URL.createObjectURL(blob)
            const a = document.createElement('a')

            a.setAttribute('hidden', '')
            a.setAttribute('href', url)
            a.setAttribute('download', this.title + '.csv')

            document.body.appendChild(a)
            a.click()
            document.body.removeChild(a)
        },

        async getCSV() {
            let item = this.histories
            let data = []

            for (var i = 0; i < item.length; i++) {
                data.push({
                    employee_name: item[i].employee_name,
                    company_name: item[i].company_name,
                    localdate_at: formatUXDate(item[i].localtime_at),
                    localtime_at: formatUXTime(item[i].localtime_at),
                    systemtime_at: formatUXTime(item[i].clocking_at),
                    clock_in_out: toggleInOut(item[i].clock_in_out),
                    reason_name: item[i].reason_name,
                    project_name: item[i].project_name,
                    id_number: item[i].id_number,
                    location: item[i].location,
                    geolocation_code: item[i].geolocation_code,
                    geolocation_name: item[i].geolocation_name
                })
            }

            const csvData = this.objectToCSV(data)
            this.download(csvData)
        },

        printPDF() {
            const doc = new jsPDF({
                orientation: 'landscape'
            })
            let item = this.histories

            var head = [
                    { title: 'FULL NAME', dataKey: 'employee_name' },
                    { title: 'COMPANY', dataKey: 'company_name' },
                    { title: 'DATE TIME', dataKey: 'localtime_at' },
                    { title: 'SYSTEM DATE TIME', dataKey: 'systemtime_at' },
                    { title: 'IN/OUT', dataKey: 'clock_in_out' },
                    { title: 'REASON', dataKey: 'reason_name' },
                    { title: 'PROJECT', dataKey: 'project_name' },
                    { title: 'ID', dataKey: 'id_number' },
                    { title: 'LOCATION', dataKey: 'location' },
                    { title: 'GEOLOCATION CODE', dataKey: 'geolocation_code' },
                    { title: 'GEOLOCATION NAME', dataKey: 'geolocation_name' },
            ]

            let body = []

            for (var i = 0; i < item.length; i++) {
                body.push({
                        employee_name: item[i].employee_name,
                        company_name: item[i].company_name,
                        localtime_at: formatUXDateTime(item[i].localtime_at),
                        systemtime_at: formatUXDateTime(item[i].clocking_at),
                        //localtime_at: moment(item[i].localtime_at).format('HH:MM:ss'),
                        clock_in_out: toggleInOut(item[i].clock_in_out),
                        reason_name: item[i].reason_name,
                        project_name: item[i].project_name,
                        id_number: item[i].id_number,
                        location: item[i].location,
                        geolocation_code: item[i].geolocation_code,
                        geolocation_name: item[i].geolocation_name
                    })
            }
            doc.text(this.title, 10, 10)
            doc.autoTable(head, body)
            doc.save(this.title + '.pdf')
        }
    },


    created() {
        //this.loadHistory()
        /*
        this.getDataFromAPI()
        .then(data => {
            this.histories = data.items
            this.totalHistories - data.total
        })
        */
        this.retriveProjects();
        this.retriveReasons();
        this.retriveCompanies();
        this.retriveGeolocation();
    }

}
</script>



// WEBPACK FOOTER //
// src/components/history/History.vue